/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { UserEntity } from './user-entity';
export class TokenEntity extends Entity {
  createdAt: string | null = null;
  expiresAt: string | null = null;
  id: string = '';
  policy: Record<string, unknown> | null = null;
  updatedAt: string | null = null;
  user: UserEntity | null = null;
  userId: string | null = null;
  static override key = 'Token';
  static override get schema() {
    return {
      user: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Token' in input
    ) {
      const { Token: wrapped, ...rest } = input as {
        Token: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}